module.exports = __webpack_public_path__ + "static/media/img-reason-card-bg@2x.bee94677.png";